import { format } from 'date-fns';
import { getDuration } from '../../../../shared/utils';
import {
  FormattedVehicleGeofenceReportItemDTO,
  VehicleGeofenceFilters,
  VehicleGeofenceFiltersState,
  VehicleGeofenceReportItemDTO,
  VehicleGeofenceStatus,
} from '../types';
import { SortDirection } from '../../../../shared/utils/constants';
import { getTimezone } from '../../../../global/utils';
import { formatReportPayloadDate } from '../../../utils/helpers';
import { DURATION_FILTER } from './constants';

export const formatVehicleGeofenceReportItem = (
  vehicleGeofenceReportItem: VehicleGeofenceReportItemDTO,
): FormattedVehicleGeofenceReportItemDTO[] => {
  const { visits, ...reportBase } = vehicleGeofenceReportItem;

  if (visits.length) {
    return visits.map((visit) => ({
      ...reportBase,
      ...visit,
      id: crypto.randomUUID(),
      geofenceId: reportBase.id,
      eventTimeFormatted: format(new Date(visit.eventTime), 'HH:mm dd/MM/yyyy'),
      durationFormatted: getDuration(visit.duration),
    }));
  }

  return [
    {
      ...reportBase,
      eventTime: '',
      duration: 0,
      status: VehicleGeofenceStatus.NO_RECORD,
      id: crypto.randomUUID(),
      geofenceId: reportBase.id,
      eventTimeFormatted: '',
      durationFormatted: '',
    },
  ];
};

export const sortReportByStatus = (
  data: FormattedVehicleGeofenceReportItemDTO[],
  sortDirection: SortDirection,
) => {
  return data.slice().sort((a, b) => {
    const statusOrder: Record<VehicleGeofenceStatus, number> = {
      ENTERED: 1,
      LEFT: 2,
      WAS_HERE: 3,
      NO_RECORD: 4,
      ALL: 5,
    };

    const statusA = a.status as VehicleGeofenceStatus;
    const statusB = b.status as VehicleGeofenceStatus;

    return sortDirection === SortDirection.ASC
      ? statusOrder[statusA] - statusOrder[statusB]
      : statusOrder[statusB] - statusOrder[statusA];
  });
};

export const formatVehicleGeofenceReportPayload = (
  filters: VehicleGeofenceFiltersState,
): VehicleGeofenceFilters => {
  const durationInSeconds = DURATION_FILTER.marks.find(
    (mark) => mark.value === filters.duration,
  )?.valueInSeconds;

  return {
    transports: filters.transports,
    geofences: filters.geofences,
    duration: durationInSeconds || 0,
    start: formatReportPayloadDate(filters.start), // convert to UTC
    end: formatReportPayloadDate(filters.end), // convert to UTC
    tz: getTimezone(),
  };
};
